import { BaseError, ErrorChanel } from './base-error';

export class ResolveError extends BaseError {
  public key: any;
  public chanel: ErrorChanel = ErrorChanel.QA;
  public type = 'ResolveError';
  public name = 'ResolveError';

  constructor(key: any, type?: string) {
    super(`Resolve Error in ${type}: ${key}`);
    this.key = `${key.message}`;
  }
}
